import { BE_ADMIN_BASE } from "./environment";
import { apiGet, apiPost, apiDelete } from "./apiClient";

export const getBlockedAirlinesAPI = (opts) =>
  apiGet(`${BE_ADMIN_BASE}/airlines/blocked-airlines`, opts);

export const saveBlockedAirlineAPI = (payload, opts) =>
  apiPost(`${BE_ADMIN_BASE}/airlines/blocked-airlines/save`, payload, opts);

export const updateBlockedAirlineAPI = (id, payload, opts) =>
  apiPost(`${BE_ADMIN_BASE}/airlines/blocked-airlines/update/${id}`, payload, opts);

export const deleteBlockedAirlineAPI = (id, opts) =>
  apiDelete(`${BE_ADMIN_BASE}/airlines/blocked-airlines/delete/${id}`, opts);
